export default {
    GET_CURRENCY_NAME_SELECT: "getCurrencyNameSelect",
    SAVE_CLIENT_ID: "saveClientId",
    ADD_TO_PRICE_LISTS: "addToPriceLists",
    ADD_TO_PRICE_LISTS_BY_IDS: "addToPriceListsByIds",
    SET_CLIENT_PRICE_LISTS: "setClientPriceLists",
    SAVE_CLIENT_PRICE_LISTS: "saveClientPriceLists",
    REMOVE_CLIENT_PRICE_LISTS: "removeClientPriceLists",
    UNSET_CLIENT_PRICE_LISTS: "unsetClientPriceLists",
    FETCH_PRICE_LIST: "fetchPriceList",
    CHECK_CLIENT_IS_READY: "checkClientIsReady",
    GET_GUS_INFO: "getGusInfo",
    GET_GUS_INFO_NOT_LOGGED: "getGusInfoNotLogged",
    CHECK_USER_DATA_EXIST_IN_SYSTEM: "checkUserDataExistInSystem",
    CHECK_USER_DATA_EXIST_IN_SYSTEM_AS_GUEST : "checkUserDataExistsInSystemAsGuest"
};
